
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 21 26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.163 24.8h-12.4a3.449 3.449 0 01-3.445-3.445v-12.4a3.448 3.448 0 013.445-3.444.689.689 0 110 1.378c-1.14 0-2.067.927-2.067 2.067v12.4c0 1.14.927 2.066 2.067 2.066h12.4a2.07 2.07 0 002.067-2.066v-12.4a2.07 2.07 0 00-2.067-2.067.688.688 0 110-1.378 3.448 3.448 0 013.444 3.444v12.4c0 1.9-1.545 3.445-3.444 3.445zM12.788 2.475a.702.702 0 01-.498 1.198.701.701 0 01-.498-.205l-1.184-1.181v16.85a.703.703 0 01-1.408 0V2.404L8.133 3.468a.701.701 0 01-.995 0 .7.7 0 010-.993L9.416.203c.15-.15.35-.215.547-.201a.7.7 0 01.547.2l2.278 2.273z"}})])
          )
        }
      }
    